import { ListView } from './apiclientfactory';
import { Api, ApiResponse } from './api';

export type AdminResourceResponse = CompleteEntityData & {results: { id: number, general: any, langs: any } };

export type SortingData = {
    sorting: string[],
    mapping?: Record<string, any> & { sorting_field: string }
};
export type SortingResponse = { saved: Record<number, any> };
export type CompleteEntityData = {
    general: Record<string, unknown>,
    langs: Record<string, Record<string, unknown>>,
    misc: { revisionComment?: string|null }
};

export class AdminResourceApi<T = void> {
    constructor(
        public readonly url: string,
        public readonly resource: string,
        public readonly api: typeof Api,
    ) {}

    async get(lang: string = null, params: URLSearchParams = null): Promise<ApiResponse<ListView<T>[]>> {
        return this.api.api_get<ListView<T>[]>(`${this.url}/api/admin_resource/${this.resource}?${params?.toString()}`, lang);
    }

    async getFiltered(filter: Record<string, unknown>, params?: URLSearchParams | null, idList: number[] = []): Promise<ApiResponse<ListView<T>[]>> {
        if (idList.length > 0) filter.__idList = idList;
        return this.api.api_post<ListView<T>[]>(`${this.url}/api/admin_resource/${this.resource}?${params?.toString()}`, filter);
    }

    async saveSorting(data: SortingData): Promise<ApiResponse<SortingResponse>> {
        return this.api.api_put<SortingResponse>(`${this.url}/api/admin_resource/${this.resource}/sorting`, data);
    }

    async saveCompleteEntity(data: CompleteEntityData): Promise<ApiResponse<AdminResourceResponse>> {
        return this.api.api_post<AdminResourceResponse>(`${this.url}/api/admin_resource/${this.resource}/save`, data);
    }
}
